/* Kahwa - WCAG 2.2 AA remediation, second layer (V2.5, 2026-09-24).
   Additive only. No theme handler is replaced or unbound, and nothing here
   sets position, display or layout on theme-owned elements. */
(function () {
  'use strict';

  /* 4.1.2 - desktop nav dropdown wrappers (<hover-disclosure>) carried
     role="button" while containing links, which is nested-interactive. The
     theme's component reads only aria-controls from the wrapper and tracks its
     own state with classes, so the disclosure state is moved onto the top-level
     link, which is the control keyboard users actually focus. aria-controls
     stays on the wrapper because the component reads it on construction. */
  function fixNavDisclosures() {
    document.querySelectorAll('hover-disclosure').forEach(function (w) {
      var link = w.querySelector('[data-top-link]');
      if (!link) return;
      function move() {
        if (w.getAttribute('role') === 'button') w.removeAttribute('role');
        if (w.hasAttribute('aria-haspopup')) w.removeAttribute('aria-haspopup');
        var exp = w.getAttribute('aria-expanded');
        if (exp !== null) {
          link.setAttribute('aria-expanded', exp);
          w.removeAttribute('aria-expanded');
        }
        var ctl = w.getAttribute('aria-controls');
        if (ctl && !link.hasAttribute('aria-controls')) link.setAttribute('aria-controls', ctl);
      }
      move();
      if (!w.hasAttribute('data-kahwa-nav')) {
        w.setAttribute('data-kahwa-nav', '');
        new MutationObserver(move).observe(w, { attributes: true, attributeFilter: ['role', 'aria-haspopup', 'aria-expanded'] });
      }
    });
  }

  /* 4.1.3 - adding to cart produced no status message. */
  var live = null;
  function announce(msg) {
    if (!live) return;
    live.textContent = '';
    window.setTimeout(function () { live.textContent = msg; }, 100);
  }
  function addStatusRegion() {
    live = document.createElement('div');
    live.setAttribute('role', 'status');
    live.setAttribute('aria-live', 'polite');
    live.setAttribute('data-kahwa-status', '');
    live.style.cssText = 'position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0 0 0 0);clip-path:inset(50%);white-space:nowrap;border:0;';
    document.body.appendChild(live);
    document.addEventListener('theme:product:added', function () { announce('Item added to your cart.'); });
    document.addEventListener('theme:product:add-error', function () { announce('The item could not be added to your cart.'); });
  }

  /* 2.4.3 / 2.1.2 - cart drawer Tab containment in WebKit (Safari).
     Tested 9/24: in Chromium the theme's own focus trap holds; in WebKit it
     intermittently lets Tab leave the drawer after the last control (Check
     Out) and strands focus on the product gallery behind it, on the live theme
     as well. This adds a plain keydown wrap plus a focusin guard, active only
     while the drawer has the theme's is-open class. It does not use inert (an
     inert-based attempt dropped focus to <body> in WebKit), does not move focus
     on open or close (the theme already does both), and steps aside for any
     other open modal dialog, such as the Klaviyo signup popup. */
  function trapCartDrawer() {
    var d = document.getElementById('cart-drawer');
    if (!d) return;
    var sel = 'a[href], area[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), summary, iframe, [tabindex]:not([tabindex="-1"])';
    function isOpen() { return d.classList.contains('is-open'); }
    function items() {
      return Array.prototype.filter.call(d.querySelectorAll(sel), function (e) {
        if (e.closest('[inert], [hidden]')) return false;
        if (!e.getClientRects().length) return false;
        return getComputedStyle(e).visibility !== 'hidden';
      });
    }
    function otherModal(el) {
      var m = el && el.closest && el.closest('[aria-modal="true"], dialog[open]');
      return !!(m && !d.contains(m));
    }
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab' || !isOpen()) return;
      var a = document.activeElement;
      if (otherModal(a)) return;
      var f = items();
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (!d.contains(a)) { e.preventDefault(); (e.shiftKey ? last : first).focus(); return; }
      if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
      else if (e.shiftKey && a === first) { e.preventDefault(); last.focus(); }
    }, true);
    document.addEventListener('focusin', function (e) {
      if (!isOpen() || d.contains(e.target) || otherModal(e.target)) return;
      var f = items();
      if (f.length) f[0].focus();
    });
  }

  function init() {
    fixNavDisclosures();
    addStatusRegion();
    trapCartDrawer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
